import '../vendor';

import '../general/ofi';
import '../general/btn-up';
import '../general/bac-video';
import '../general/hidden';
import '../general/additional-sl';




// WEBPACK FOOTER //
// ./src/js/pages/home-page.js